module.exports = __webpack_public_path__ + "static/media/rooftent.d5c43104.jpeg";